<template>
  <button @click="$emit('click')" :disabled="disabled" type="button" class="primary-button" v-html="text">

  </button>
</template>

<script>
import buttonMixin from "@/components/Functional/Buttons/buttonMixin";

export default {
  name: "PrimaryButton",
  mixins: [buttonMixin]
}
</script>

<style scoped>

</style>
